import React from "react";
import {ListItem} from "@mui/material";
import List from "@mui/material/List";
import DeleteIcon from "@mui/icons-material/Delete";
import RenderOnRole from "../../RenderOnRole";


function ListSelectedComponenttype({selectedComponenttypes, deleteComponenttype}) {
    return (
        <>
            {selectedComponenttypes?.map((item) => (
                <List key={item.objecttype_id}>
                    <ListItem style={{paddingTop: "0px", paddingBottom: "0px", alignItems: "normal"}}>
                        <div style={{float: "left", width: "30px", height: "25px"}}>
                            <RenderOnRole roles={['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN']}>
                                <DeleteIcon onClick={() => deleteComponenttype(item.objecttype_id)}/>
                            </RenderOnRole>
                        </div>
                        {item.code} - {item.name}
                    </ListItem>
                    {item.attribute?.map((attr) => (
                        <div key={attr.attribute_id} style={{marginLeft: "2em", paddingTop: "0px", paddingBottom: "0px", alignItems: "normal"}}>
                            <div style={{float: "left", marginLeft: "2em"}}>{attr.name}</div>
                            <div style={{clear: "both"}}></div>
                        </div>
                    ))}
                </List>
            ))}
        </>
    );
}

export default ListSelectedComponenttype;
